import { initAnalytics } from "./analytics";
import { killParralax, updateFrameRateTracking } from "./frameRateTracking";
import { initMenu } from "./menu";
import { initVideo } from "./video";
import { initMountainScene, updateMountainScene } from "./mountainScene";
import { updateSpaceScene, initSpaceManOrbit } from "./spaceScene";
import { writeActiveSection, initSections, updateCachedMeasurements } from "./sections";
import { seamless } from 'seamless-scroll-polyfill/dist/seamless.esm';

function browserWarning() {
  // Warn users their browser sucks
  const warning = `<p class="browserupgrade">Your browser is out of date and may not render this website properly. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security.</p>`;
  document.body.insertAdjacentHTML('afterbegin', warning);
}

function initApp() {
  // Polyfill smooth scroll
  seamless();

  // State for section positions
  window.jmAppState = {
    layoutDirty: true,
    windowHeight: null,
    windowWidth: null,
    pageHeight: null,
    scrollTop: null,
    trueScrollTop: null,
    sections: [],
    activeSection: null,
    renderKey: null,
    scrollingSection: false,
    spaceScene: {
      lastRenderedCacheKey: '',
      planes: {
        earth: {
          scene: document.querySelector('#contact .earth'),
          shift: .3,
          zoom: 1.2,
        },
        spaceman: {
          scene: document.querySelector('#contact .astronaut'),
          shift: 1,
          zoom: 3,
        },
      },
    },
    mountainScene: {
      lastRenderedCacheKey: '',
      planes: {
        sky: {
          scene: document.querySelector('.mountainScene #sky'),
          shift: .12,
        },
        background: {
          haze: document.querySelector('.mountainScene #bgHazeSunsetRect'),
          scene: document.querySelector('.mountainScene #bg'),
          shift: .3,
        },
        midground: {
          haze: document.querySelector('.mountainScene #mgHazeSunset'),
          scene: document.querySelector('.mountainScene #mg'),
          shift: .4,
        },
        foreground: {
          haze: document.querySelector('.mountainScene #fgHazeSunset'),
          scene: document.querySelector('.mountainScene #fg'),
          shift: .7,
        },
      },
      logo: document.querySelector('.mountainScene .logo'),
      logoShift: .5,
      buttons: document.querySelector('.mountainScene .buttons'),
      night: document.querySelector('.mountainScene .night'),
      haze: document.querySelector('.mountainScene #bgHaze'),
      preloadImageUrls: [
        '/images/mountain-scene/mountains-bg.png?v=5',
        '/images/mountain-scene/mountains-fg.png?v=5',
        '/images/mountain-scene/mountains-mg.png?v=5',
        '/images/mountain-scene/mountains.jpg?v=5',
        '/images/mountain-scene/sky.jpg?v=5',
      ],
    },
  };

  // Initialisation
  initSections();
  initMountainScene();
  initSpaceManOrbit();
  initMenu();
  initVideo();
  initAnalytics();

  // Frame rendering
  const renderFrame = function () {
    // Reads
    updateCachedMeasurements();
    const renderKey = [
      window.jmAppState.windowHeight,
      window.jmAppState.windowWidth,
      window.jmAppState.pageHeight,
      window.jmAppState.scrollTop,
    ].join();
    // Writes
    if (renderKey !== window.jmAppState.renderKey) {
      window.jmAppState.renderKey = renderKey;
      writeActiveSection();
      // testAnimation();
      if (!window.jmAppState.parralaxKilled) {
        updateMountainScene();
        updateSpaceScene();
        if (window.jmAppState.killParralax) {
          killParralax();
        }
      }
    }
    updateFrameRateTracking();
    requestAnimationFrame(renderFrame);
  }
  renderFrame();
}

// Cut the mustard - don't bother with scripts on old browsers
if (document.documentElement.classList.contains('js')) {
  initApp();
} else {
  browserWarning();
}